export default __webpack_public_path__ + "static/media/hero-video-tablet-es.7497d941.png";